import React, { useEffect, useRef, useState } from "react";

const ImplementationServicesCTASection = () => {
  const ctaRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );

    if (ctaRef.current) observer.observe(ctaRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="implementation-services-cta-section py-5">
      <div
        ref={ctaRef}
        className={`cta-hris-card text-center rounded-4 p-5 ${
          isVisible ? "zoom-in" : ""
        }`}
      >
        <h2 className="CTA-TITLE fw-bold mb-4">
          Is It Time to Upgrade Your Document Management?
        </h2>
        <p className="mb-4 fs-5 text-dark">
          Discover how leading organizations have modernized their document
          processes with our advanced digital platform. Book a demo today and
          explore smarter ways to store, manage, and collaborate on your
          documents.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <button
            type="button"
            className="btn"
            style={{
              backgroundColor: "#020248",
              color: "white",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "15px",
              border: "0 solid transparent",
            }}
            onClick={() => {
              const modal = new window.bootstrap.Modal(
                document.getElementById("demoRequestModal")
              );
              modal.show();
            }}
          >
            Request Demo
          </button>
          <button className="btn-btn-demo px-4 py-2 fw-semibold"
          onClick={() => window.location.href = "/contact"}
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default ImplementationServicesCTASection;
